import React from 'react'
import { map, compose, defaultTo } from 'ramda'

export const openGraphMetaActors = compose(map((actor) => {
  return [
    <meta property="og:video:actor" content={actor.name} />
  ]
}), defaultTo([]))
